var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers38Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-16.000000, -1182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3-Copy-2",
    transform: "translate(16.000000, 1182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L35.4361148,1.03584031e-16 C36.3276335,-6.01853049e-17 36.6509198,0.0928256111 36.9768457,0.267132704 C37.3027716,0.441439796 37.5585602,0.697228371 37.7328673,1.0231543 C37.9071744,1.34908022 38,1.67236646 38,2.5638852 L38,35.4361148 C38,36.3276335 37.9071744,36.6509198 37.7328673,36.9768457 C37.5585602,37.3027716 37.3027716,37.5585602 36.9768457,37.7328673 C36.6509198,37.9071744 36.3276335,38 35.4361148,38 L2.5638852,38 C1.67236646,38 1.34908022,37.9071744 1.0231543,37.7328673 C0.697228371,37.5585602 0.441439796,37.3027716 0.267132704,36.9768457 C0.0928256111,36.6509198 4.01235366e-17,36.3276335 -6.90560205e-17,35.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.000000, 11.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2421053,3.11578947 C11.2842105,1.43157895 9.89473684,0 8.21052632,0 C8.16842105,0 8.12631579,0 8.08421053,0 C6.35789474,0 4.84210526,1.38947326 4.92631579,3.11578947 C4.92631579,3.45263158 5.26315789,5.22105263 5.26315789,5.22105263 C5.51578947,6.73684211 6.52631579,8 8.08421053,8 C9.64210526,8 10.6105263,6.73684211 10.9052632,5.22105263 C10.9052632,5.22105263 11.2421053,3.49473684 11.2421053,3.11578947 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8736842,16 L0.294736842,16 L0.547368842,12.9684211 C0.673684632,11.8315789 1.852632,11.0315789 3.03157937,10.8210526 L3.03157937,10.8210526 C6.38528232,10.3738922 9.78338303,10.3720524 13.1375682,10.815581 L13.1789474,10.8210526 C14.4842105,11.0736842 15.6210526,11.7894737 15.7052632,13.0947368 L15.8736842,16 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4526316,5.22105263 C19.4526316,3.83157895 18.3157895,2.69473684 16.9263158,2.69473684 C15.5368421,2.69473684 14.4,3.83157895 14.4,5.22105263 C14.4,5.51578947 14.6947368,6.86315789 14.6947368,6.86315789 C14.9052632,8.04210526 15.7052632,9.05263158 16.9263158,9.05263158 C18.1473684,9.05263158 18.9473684,8.04210526 19.1578947,6.86315789 C19.2,6.86315789 19.4526316,5.47368421 19.4526316,5.22105263 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9263158,10.9473684 L21.0947368,11.4526316 C22.1052632,11.6210526 23.0315789,12.2105263 23.1157895,13.3052632 L23.2421053,16 L18.4,16",
    id: "Stroke-7"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers38Px);
export default __webpack_public_path__ + "static/media/Icon_Users-38px.635a3e15c9e93cf682b7ee7bc991657c.svg";
export { ForwardRef as ReactComponent };